import Bugsnag from '@bugsnag/js'
import { DefaultError } from 'errors/components/DefaultError'
import { Component, ErrorInfo, ReactNode } from 'react'

type Props = {
  children: ReactNode
  fallback?: ReactNode
  onError?: (error: Error, errorInfo: ErrorInfo) => void
}

type State = {
  hasError: boolean
}

export class GenericErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('UNCAUGHT ERROR:', error, errorInfo)
    if (this.props.onError) {
      this.props.onError(error, errorInfo)
    } else {
      Bugsnag.notify(error, (event) => {
        event.severity = 'error'
        event.addMetadata('Error Boundary', { error: errorInfo })
      })
    }
  }

  render() {
    const { hasError } = this.state
    if (hasError) {
      return <DefaultError />
    }

    const { children } = this.props

    return children
  }
}
